import { MapperBase } from '../../utilities/mapper-base';
import { FactResource } from '../resource/fact.resource';
import { Fact } from '../ui/fact.model';
import { LinkedDocument } from '../ui/linked-document.model';
import { LinkedIssue } from '../ui/linked-issue.model';
import { LinkedCustodian } from '../ui/linked-custodian.model';
import { DateUtility } from '../../utilities/date.utility';


export class FactResourceToFactMapper extends MapperBase<FactResource, Fact> {
	map(source: FactResource): Fact {
		const dest = new Fact();
		dest.id = source.factId;
		dest.caseId = source.caseId;
		dest.title = source.factTitle;
		dest.dateStart = DateUtility.toISO(source.dateStart);
		dest.dateEnd = DateUtility.toISO(source.dateEnd);
		dest.contested = source.contested;
		dest.material = source.material;
		dest.linkedCustodians = source?.custodians?.map((item) => {
			const linkedCustodian = new LinkedCustodian();
			linkedCustodian.id = item.custodianId;
			linkedCustodian.name = item.name;
			return linkedCustodian;
		}) || [];
		dest.linkedDocuments = source?.docsInFacts?.map((item) => {
			const linkedDocument = new LinkedDocument();
			linkedDocument.factId = item.factId;
			linkedDocument.documentId = item.docId;
			linkedDocument.caseId = item.caseId;
			linkedDocument.pageNumber = item.pageNumber;
			if (item.doc) {
				linkedDocument.documentTitle = `${ item?.doc.docTitle ?? '' }${ item?.doc?.docExtension ?? '' } (p. ${ linkedDocument.pageNumber })`;
			}
			return linkedDocument;
		}) || [];
		dest.linkedIssues = source?.issues?.map((item) => {
			const linkedIssue = new LinkedIssue();
			linkedIssue.id = item.issueId;
			linkedIssue.title = item.issueTitle;
			linkedIssue.description = item.description;
			return linkedIssue;
		}) || [];
		return dest;
	}
}

